/**
 * @generated SignedSource<<18f4211a1cbd677f3a3ccaacfbe54550>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ControlUpdateUserInput = {
  canCreateMultipleTrials?: boolean | null;
  userId: string;
};
export type ControlUserDetailPage_updateUserMutation$variables = {
  input: ControlUpdateUserInput;
};
export type ControlUserDetailPage_updateUserMutation$data = {
  readonly controlUpdateUser: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly canCreateMultipleTrials: boolean;
      readonly id: string;
    } | null;
  };
};
export type ControlUserDetailPage_updateUserMutation = {
  response: ControlUserDetailPage_updateUserMutation$data;
  variables: ControlUserDetailPage_updateUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ControlUpdateUserResponse",
    "kind": "LinkedField",
    "name": "controlUpdateUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ControlUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreateMultipleTrials",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ControlUserDetailPage_updateUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ControlUserDetailPage_updateUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8e7074afb31a97dcb73235476b4e46de",
    "id": null,
    "metadata": {},
    "name": "ControlUserDetailPage_updateUserMutation",
    "operationKind": "mutation",
    "text": "mutation ControlUserDetailPage_updateUserMutation(\n  $input: ControlUpdateUserInput!\n) {\n  controlUpdateUser(input: $input) {\n    node {\n      id\n      canCreateMultipleTrials\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7aa5354509a3c1b8b0eeb14d5f57d8ae";

export default node;
